import { useContext, useState } from "react";
import { FaSolarPanel } from "react-icons/fa";
import UserContext from "../../User/UserContext";
import LoadingCircle from "../../utility/LoadingCircle";

const SolarGradeUpdateButton = ({ projectId, solarGradeIds }) => {
	let { api, token } = useContext(UserContext);
	const [saving, setSaving] = useState(false);
	const updateSolarGradeProject = (e) => {
		e.preventDefault();
		setSaving(true);
		fetch(api + "/project/update-solar-grade/" + projectId, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
			body: JSON.stringify({ ...solarGradeIds }),
		}).then((res) => {
			if (!res.ok) {
				alert("An error occurred. Unable to send data to Solar Grade.");
			}
			setSaving(false);
		});
	};
	return (
		<>
			{saving ? (
				<div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-70 z-[3000] flex justify-center items-center">
					<div className="bg-gray-50 rounded-md p-4 flex flex-col justify-center items-center">
						<LoadingCircle />
						<p className="text-black">Uploading to Solar Grade...</p>
					</div>
				</div>
			) : null}

			<button
				className="flex items-center gap-1  bg-blue-600 hover:bg-blue-700 p-2 rounded-lg w-full cursor-pointer select-none"
				onClick={updateSolarGradeProject}>
				<FaSolarPanel />
				<p>Update Solar Grade</p>
			</button>
		</>
	);
};

export default SolarGradeUpdateButton;
